export const container = {
    display: 'flex',
    alignItems: 'flex-start',

    flexDirection: 'column',

    tablet: {
        flexDirection: 'row',
    },
};

export const quotes = {
    width: '1.5rem',
    height: '1.5rem',
};

export const extendText = ({ color, theme: { fonts } }) => ({
    ...fonts.heroNewBold,
    fontSize: '1.5rem',
    lineHeight: '2.625rem',
    marginTop: '2.5rem',
    color,

    tablet: {
        fontSize: '2rem',
        marginTop: '-0.5rem',
        marginLeft: '1rem',
        lineHeight: '2.625rem',
    },
});
